const sortByHelper = (key) => (a, b) => (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0)
const sortBy = (arr: any[], key: string) => arr.concat().sort(sortByHelper(key))
const keyBy = (arr: any[], key: string) => (arr || []).reduce((r, x) => ({ ...r, [key ? x[key] : x]: x }), {})
export default { sortBy, keyBy }

// module.exports = {sortBy, keyBye};
